import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import styled, { css } from 'styled-components';
import { Tooltip } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useLayoutContext } from './layout';
import { media } from '../../hooks/use-responsive-v2.hook';
import { sizes } from '../../style-foundation';
import { MenuDropdown } from '../dropdown';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledSider = styled.aside.withConfig({
  displayName: "layoutSider__StyledSider",
  componentId: "sc-jkik8j-0"
})(["flex:0 0 auto;height:100%;min-height:100%;width:", ";min-width:", ";max-width:", ";background:#ffffff;overflow-x:hidden;overflow-y:auto;transition:all 0.3s cubic-bezier(0.4,0,0.2,1);position:relative;z-index:10;border-right:1px solid rgba(148,163,184,0.25);box-shadow:none;&::-webkit-scrollbar{width:6px;}&::-webkit-scrollbar-track{background:rgba(255,255,255,0.05);}&::-webkit-scrollbar-thumb{background:rgba(255,255,255,0.2);border-radius:3px;}&::-webkit-scrollbar-thumb:hover{background:rgba(255,255,255,0.3);}", "{width:", ";min-width:", ";max-width:", ";}", "{position:", ";top:0;left:0;bottom:0;width:", ";min-width:", ";max-width:", ";transform:", ";box-shadow:", ";z-index:1000;", "}"], function (props) {
  return props.$collapsed ? "".concat(props.$collapsedWidth, "px") : "".concat(props.$width, "px");
}, function (props) {
  return props.$collapsed ? "".concat(props.$collapsedWidth, "px") : "".concat(props.$width, "px");
}, function (props) {
  return props.$collapsed ? "".concat(props.$collapsedWidth, "px") : "".concat(props.$width, "px");
}, media.tablet, function (props) {
  return props.$collapsed ? "".concat(props.$collapsedWidth, "px") : '200px';
}, function (props) {
  return props.$collapsed ? "".concat(props.$collapsedWidth, "px") : '200px';
}, function (props) {
  return props.$collapsed ? "".concat(props.$collapsedWidth, "px") : '200px';
}, media.mobile, function (props) {
  return props.$locked ? 'relative' : 'fixed';
}, function (props) {
  return props.$locked ? "".concat(props.$collapsed ? props.$collapsedWidth : props.$width, "px") : '280px';
}, function (props) {
  return props.$locked ? "".concat(props.$collapsed ? props.$collapsedWidth : props.$width, "px") : '280px';
}, function (props) {
  return props.$locked ? "".concat(props.$collapsed ? props.$collapsedWidth : props.$width, "px") : '280px';
}, function (props) {
  return props.$collapsed && !props.$locked ? 'translateX(-100%)' : 'translateX(0)';
}, function (props) {
  return props.$locked || props.$collapsed ? 'none' : '2px 0 8px rgba(0, 0, 0, 0.15)';
}, function (props) {
  return props.$locked && props.$collapsed && css([".menu-item-content{justify-content:center;padding:0;}.menu-label,.menu-arrow{display:none !important;}"]);
});
var Overlay = styled.div.withConfig({
  displayName: "layoutSider__Overlay",
  componentId: "sc-jkik8j-1"
})(["display:none;", "{display:", ";position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.45);z-index:999;transition:opacity 0.3s;}"], media.mobile, function (props) {
  return props.$visible ? 'block' : 'none';
});
var MenuContainer = styled.nav.withConfig({
  displayName: "layoutSider__MenuContainer",
  componentId: "sc-jkik8j-2"
})(["flex:1;min-height:0;overflow-y:auto;margin-top:16px;"]);
var SiderBottom = styled.div.withConfig({
  displayName: "layoutSider__SiderBottom",
  componentId: "sc-jkik8j-3"
})(["flex-shrink:0;border-top:1px solid rgba(100,116,139,0.16);padding:8px 0 12px;display:flex;flex-direction:column;gap:4px;", "{display:none;}"], media.mobile);
var SiderBottomItem = styled.button.withConfig({
  displayName: "layoutSider__SiderBottomItem",
  componentId: "sc-jkik8j-4"
})(["display:flex;align-items:center;justify-content:", ";gap:12px;width:100%;min-height:40px;padding:", ";border:none;background:transparent;color:#334155;font-size:14px;font-weight:500;cursor:pointer;text-align:left;transition:color 0.2s ease;.bottom-item-icon{font-size:18px;min-width:18px;display:flex;align-items:center;justify-content:center;color:inherit;}.bottom-item-label{display:", ";white-space:nowrap;}&:hover{color:#0b48e5;}"], function (props) {
  return props.$collapsed ? 'center' : 'flex-start';
}, function (props) {
  return props.$collapsed ? '10px 0' : '10px 24px';
}, function (props) {
  return props.$collapsed ? 'none' : 'inline';
});
var SiderTrigger = styled.button.withConfig({
  displayName: "layoutSider__SiderTrigger",
  componentId: "sc-jkik8j-5"
})(["display:flex;align-items:center;justify-content:", ";gap:12px;width:100%;min-height:40px;padding:", ";border:none;background:transparent;color:#334155;font-size:14px;font-weight:500;cursor:pointer;text-align:left;transition:color 0.2s ease;.trigger-icon{font-size:18px;min-width:18px;display:flex;align-items:center;justify-content:center;}.trigger-label{display:", ";white-space:nowrap;}&:hover{color:#0b48e5;}", "{display:none;}"], function (props) {
  return props.$collapsed ? 'center' : 'flex-start';
}, function (props) {
  return props.$collapsed ? '10px 0' : '10px 24px';
}, function (props) {
  return props.$collapsed ? 'none' : 'inline';
}, media.mobile);
var SiderInner = styled.div.withConfig({
  displayName: "layoutSider__SiderInner",
  componentId: "sc-jkik8j-6"
})(["min-height:100%;display:flex;flex-direction:column;"]);
var TopContentSlot = styled.div.withConfig({
  displayName: "layoutSider__TopContentSlot",
  componentId: "sc-jkik8j-7"
})(["padding:12px;"]);
var MenuItemWrapper = styled.div.withConfig({
  displayName: "layoutSider__MenuItemWrapper",
  componentId: "sc-jkik8j-8"
})(["position:relative;.menu-item-content{display:flex;align-items:center;justify-content:", ";gap:8px;padding:", ";color:", ";background:", ";cursor:pointer;transition:all 0.2s ease;white-space:nowrap;font-weight:500;min-height:40px;height:auto;border-radius:12px;margin:0 12px 8px;width:calc(100% - 24px);box-sizing:border-box;&:hover{background:", ";color:", ";}.menu-icon{font-size:20px;min-width:20px;display:flex;align-items:center;justify-content:center;color:inherit;}.menu-label{flex:1;display:", ";}.menu-arrow{font-size:12px;transition:transform 0.3s;display:", ";color:inherit;&.expanded{transform:rotate(180deg);}}}", "{.menu-item-content{justify-content:flex-start;padding:12px 24px;}.menu-label,.menu-arrow{display:block !important;}}"], function (props) {
  return props.$collapsed ? 'center' : 'flex-start';
}, function (props) {
  return props.$collapsed ? '0' : '12px 24px';
}, function (props) {
  return props.$selected ? '#3366ff' : '#4a4a4a';
}, function (props) {
  return props.$selected ? '#e8f4f8' : 'transparent';
}, function (props) {
  return props.$selected ? '#e8f4f8' : 'rgba(0, 0, 0, 0.04)';
}, function (props) {
  return props.$selected ? '#3366ff' : '#3366ff';
}, function (props) {
  return props.$collapsed ? 'none' : 'block';
}, function (props) {
  return props.$collapsed ? 'none' : 'block';
}, media.mobile); // Render outside the sider so nested sidebars cannot cover or clip the popup.

var SubMenuPopup = styled.div.withConfig({
  displayName: "layoutSider__SubMenuPopup",
  componentId: "sc-jkik8j-9"
})(["position:fixed;min-width:200px;background:#ffffff;box-shadow:0 3px 6px -4px rgba(0,0,0,0.12),0 6px 16px 0 rgba(0,0,0,0.08),0 9px 28px 8px rgba(0,0,0,0.05);border-radius:8px;padding:4px 0;z-index:1050;", "{display:", ";}"], media.mobile, function (props) {
  return props.$locked ? 'block' : 'none';
});
var SubMenuContainer = styled.div.withConfig({
  displayName: "layoutSider__SubMenuContainer",
  componentId: "sc-jkik8j-10"
})(["max-height:", ";overflow:hidden;transition:max-height 0.3s ease-in-out;background:transparent;", "{display:", ";}"], function (props) {
  return props.$expanded ? '500px' : '0';
}, media.tabletAndAbove, function (props) {
  return props.$collapsed ? 'none' : 'block';
});
var SubMenuItem = styled.div.withConfig({
  displayName: "layoutSider__SubMenuItem",
  componentId: "sc-jkik8j-11"
})(["display:flex;align-items:center;padding:12px 24px 12px 70px;min-height:40px;box-sizing:border-box;color:", ";background:", ";cursor:pointer;transition:all 0.2s ease;white-space:nowrap;font-weight:500;border-radius:12px;margin:0 12px 8px;width:calc(100% - 24px);&:hover{background:", ";color:#3366ff;}.submenu-label{flex:1;}"], function (props) {
  return props.$selected ? '#3366ff' : '#4a4a4a';
}, function (props) {
  return props.$selected ? '#e8f4f8' : 'transparent';
}, function (props) {
  return props.$selected ? '#e8f4f8' : 'rgba(0, 0, 0, 0.04)';
});
var PopupMenuItem = styled.div.withConfig({
  displayName: "layoutSider__PopupMenuItem",
  componentId: "sc-jkik8j-12"
})(["display:flex;align-items:center;padding:12px 16px;min-height:40px;box-sizing:border-box;color:", ";background:", ";cursor:pointer;transition:all 0.2s ease;white-space:nowrap;font-weight:500;border-radius:12px;margin:4px 8px;&:hover{background:", ";color:#3366ff;}"], function (props) {
  return props.$selected ? '#3366ff' : '#4a4a4a';
}, function (props) {
  return props.$selected ? '#e8f4f8' : 'transparent';
}, function (props) {
  return props.$selected ? '#e8f4f8' : 'rgba(0, 0, 0, 0.04)';
});
export var LayoutSider = function LayoutSider(_ref) {
  var items = _ref.items,
      bottomItems = _ref.bottomItems,
      children = _ref.children,
      topContent = _ref.topContent,
      _ref$collapsedWidth = _ref.collapsedWidth,
      collapsedWidth = _ref$collapsedWidth === void 0 ? 80 : _ref$collapsedWidth,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 240 : _ref$width,
      _ref$defaultOpenKeys = _ref.defaultOpenKeys,
      defaultOpenKeys = _ref$defaultOpenKeys === void 0 ? [] : _ref$defaultOpenKeys,
      _ref$openKeys = _ref.openKeys,
      openKeys = _ref$openKeys === void 0 ? [] : _ref$openKeys,
      _ref$selectedKeys = _ref.selectedKeys,
      selectedKeys = _ref$selectedKeys === void 0 ? [] : _ref$selectedKeys,
      _ref$collapseLabel = _ref.collapseLabel,
      collapseLabel = _ref$collapseLabel === void 0 ? 'Collapse sidebar' : _ref$collapseLabel,
      _ref$expandLabel = _ref.expandLabel,
      expandLabel = _ref$expandLabel === void 0 ? 'Expand sidebar' : _ref$expandLabel,
      forceCollapsed = _ref.forceCollapsed,
      _ref$collapsible = _ref.collapsible,
      collapsible = _ref$collapsible === void 0 ? true : _ref$collapsible;

  var _useLayoutContext = useLayoutContext(),
      collapsed = _useLayoutContext.collapsed,
      setCollapsed = _useLayoutContext.setCollapsed;

  var isCollapsed = forceCollapsed !== null && forceCollapsed !== void 0 ? forceCollapsed : collapsed;

  var _useState = useState(defaultOpenKeys),
      expandedKeys = _useState[0],
      setExpandedKeys = _useState[1];

  var _useState2 = useState(null),
      popupPosition = _useState2[0],
      setPopupPosition = _useState2[1];

  var _useState3 = useState(null),
      activePopup = _useState3[0],
      setActivePopup = _useState3[1];

  var closeTimeoutRef = React.useRef(null);

  var handleOverlayClick = function handleOverlayClick() {
    setCollapsed(true);
  };

  var toggleSubMenu = function toggleSubMenu(key) {
    setExpandedKeys(function (prev) {
      return prev.includes(key) ? prev.filter(function (k) {
        return k !== key;
      }) : [].concat(_toConsumableArray(prev), [key]);
    });
  };

  var handleMenuItemMouseEnter = function handleMenuItemMouseEnter(e, itemKey, hasChildren) {
    if (isCollapsed && hasChildren) {
      // Clear any pending close timeout
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
        closeTimeoutRef.current = null;
      }

      var rect = e.currentTarget.getBoundingClientRect();
      setPopupPosition({
        top: rect.top,
        left: rect.right + 8
      });
      setActivePopup(itemKey);
    }
  };

  var handleMenuItemMouseLeave = function handleMenuItemMouseLeave() {
    if (isCollapsed) {
      // Delay closing to allow moving to popup
      closeTimeoutRef.current = setTimeout(function () {
        setActivePopup(null);
      }, 100);
    }
  };

  var handlePopupMouseEnter = function handlePopupMouseEnter() {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
  };

  var handlePopupMouseLeave = function handlePopupMouseLeave() {
    setActivePopup(null);
  };

  var renderMenuItems = function renderMenuItems() {
    if (!items) return null;
    return items.map(function (item) {
      var _item$children, _item$children2;

      var hasChildren = item.children && item.children.length > 0;
      var isExpanded = expandedKeys.includes(item.key) || openKeys.includes(item.key);
      var isPopupActive = activePopup === item.key; // Only allow selected state for items WITHOUT children.

      var isSelected = !hasChildren && selectedKeys.includes(item.key);
      return /*#__PURE__*/_jsxs(MenuItemWrapper, {
        $collapsed: isCollapsed,
        $hasChildren: hasChildren,
        $selected: isSelected,
        children: [/*#__PURE__*/_jsx(Tooltip, {
          title: isCollapsed && !hasChildren ? item.label : '',
          placement: "right",
          children: /*#__PURE__*/_jsxs("div", {
            className: "menu-item-content",
            onMouseEnter: function onMouseEnter(e) {
              return handleMenuItemMouseEnter(e, item.key, hasChildren);
            },
            onMouseLeave: handleMenuItemMouseLeave,
            onClick: function onClick(event) {
              if (hasChildren && !isCollapsed) {
                toggleSubMenu(item.key);
              } else if (hasChildren && isCollapsed) {
                var rect = event.currentTarget.getBoundingClientRect();
                setPopupPosition({
                  top: rect.top,
                  left: rect.right + 8
                });
                setActivePopup(item.key);
              } else if (!hasChildren) {
                var _item$onClick;

                (_item$onClick = item.onClick) === null || _item$onClick === void 0 ? void 0 : _item$onClick.call(item);
              }
            },
            children: [item.icon && /*#__PURE__*/_jsx("span", {
              className: "menu-icon",
              children: item.icon
            }), /*#__PURE__*/_jsx("span", {
              className: "menu-label",
              children: item.label
            }), hasChildren && /*#__PURE__*/_jsx("span", {
              className: "menu-arrow ".concat(isExpanded ? 'expanded' : ''),
              children: "\u25BC"
            })]
          })
        }), isCollapsed && hasChildren && isPopupActive && popupPosition && /*#__PURE__*/createPortal( /*#__PURE__*/_jsx(SubMenuPopup, {
          className: "submenu-popup",
          $locked: forceCollapsed !== undefined && !collapsible,
          style: {
            top: "".concat(popupPosition.top, "px"),
            left: "".concat(popupPosition.left, "px")
          },
          onMouseEnter: handlePopupMouseEnter,
          onMouseLeave: handlePopupMouseLeave,
          children: (_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.map(function (subItem) {
            return /*#__PURE__*/_jsx(PopupMenuItem, {
              $selected: selectedKeys.includes(subItem.key),
              onClick: subItem.onClick,
              children: subItem.label
            }, subItem.key);
          })
        }), document.body), hasChildren && !isCollapsed && /*#__PURE__*/_jsx(SubMenuContainer, {
          $expanded: isExpanded,
          $collapsed: isCollapsed,
          children: (_item$children2 = item.children) === null || _item$children2 === void 0 ? void 0 : _item$children2.map(function (subItem) {
            return /*#__PURE__*/_jsx(SubMenuItem, {
              $selected: selectedKeys.includes(subItem.key),
              onClick: subItem.onClick,
              children: /*#__PURE__*/_jsx("span", {
                className: "submenu-label",
                children: subItem.label
              })
            }, subItem.key);
          })
        })]
      }, item.key);
    });
  };

  var renderBottomItems = function renderBottomItems() {
    if (!(bottomItems !== null && bottomItems !== void 0 && bottomItems.length)) return null;
    return bottomItems.map(function (item) {
      var _item$children3, _item$children4;

      var hasChildren = Boolean((_item$children3 = item.children) === null || _item$children3 === void 0 ? void 0 : _item$children3.length);

      var trigger = /*#__PURE__*/_jsx(Tooltip, {
        title: isCollapsed ? item.label : '',
        placement: "right",
        children: /*#__PURE__*/_jsxs(SiderBottomItem, {
          type: "button",
          $collapsed: isCollapsed,
          onClick: hasChildren ? undefined : item.onClick,
          "aria-label": item.label,
          "aria-haspopup": hasChildren ? 'menu' : undefined,
          children: [item.icon && /*#__PURE__*/_jsx("span", {
            className: "bottom-item-icon",
            children: item.icon
          }), /*#__PURE__*/_jsx("span", {
            className: "bottom-item-label",
            children: item.label
          })]
        })
      });

      if (!hasChildren) {
        return /*#__PURE__*/_jsx(React.Fragment, {
          children: trigger
        }, item.key);
      }

      return /*#__PURE__*/_jsx(MenuDropdown, {
        trigger: ['click'],
        placement: "topLeft",
        align: {
          points: ['bl', 'br'],
          offset: [parseFloat(sizes.gap8), 0],
          overflow: {
            adjustX: true,
            adjustY: true
          }
        },
        overlayStyle: {
          minWidth: 192
        },
        menu: {
          items: (_item$children4 = item.children) === null || _item$children4 === void 0 ? void 0 : _item$children4.map(function (child) {
            return {
              key: child.key,
              label: child.label,
              icon: child.icon,
              onClick: child.onClick
            };
          })
        },
        children: trigger
      }, item.key);
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [forceCollapsed === undefined && /*#__PURE__*/_jsx(Overlay, {
      $visible: !isCollapsed,
      onClick: handleOverlayClick
    }), /*#__PURE__*/_jsx(StyledSider, {
      $collapsed: isCollapsed,
      $width: width,
      $collapsedWidth: collapsedWidth,
      $locked: forceCollapsed !== undefined && !collapsible,
      children: /*#__PURE__*/_jsxs(SiderInner, {
        children: [topContent && /*#__PURE__*/_jsx(TopContentSlot, {
          children: topContent
        }), items ? /*#__PURE__*/_jsx(MenuContainer, {
          children: renderMenuItems()
        }) : children, bottomItems !== null && bottomItems !== void 0 && bottomItems.length || collapsible ? /*#__PURE__*/_jsxs(SiderBottom, {
          children: [renderBottomItems(), collapsible && /*#__PURE__*/_jsx(Tooltip, {
            title: isCollapsed ? expandLabel : '',
            placement: "right",
            children: /*#__PURE__*/_jsxs(SiderTrigger, {
              type: "button",
              $collapsed: isCollapsed,
              onClick: function onClick() {
                return setCollapsed(!isCollapsed);
              },
              "aria-label": isCollapsed ? expandLabel : collapseLabel,
              title: isCollapsed ? expandLabel : collapseLabel,
              children: [/*#__PURE__*/_jsx("span", {
                className: "trigger-icon",
                children: isCollapsed ? /*#__PURE__*/_jsx(RightOutlined, {}) : /*#__PURE__*/_jsx(LeftOutlined, {})
              }), /*#__PURE__*/_jsx("span", {
                className: "trigger-label",
                children: collapseLabel
              })]
            })
          })]
        }) : null]
      })
    })]
  });
};
LayoutSider.displayName = 'LayoutSider';